<template>
  <div v-if="isShowView" id="punch-card-campaign-view-wrapper">
    <div id="punch-card-campaign-view-container" :class="{ 'shown': isSlide }">
      <img src="@/assets/images/close-dark-gray.svg" alt="close-view" class="cursor-pointer" @click="slideRight">
      <b-container fluid class="view-details-container h-100">
        <div :class="['campaign-image d-flex align-items-center justify-content-center', { 'bg-light': !rewardImage }]">
          <img :src="rewardImage" :alt="campaignDetails.name" class="img-fluid" v-if="rewardImage">
        </div>
        <h3>{{ campaignDetails.name }}</h3>
        <p class="description">{{ campaignDetails.description }}</p>
        <hr>
        <b-form-group v-if="campaignDuration" label-class="view-campaign-label" label="Promo runs" class="mb-1">
          <p class="info">{{ campaignDuration }}</p>
        </b-form-group>
        <b-form-group label-class="view-campaign-label" label="Stamps to collect" class="mb-1">
          <p class="info">{{ `${campaignDetails.number_of_stamps} stickers` }}</p>
        </b-form-group>
        <b-form-group label-class="view-campaign-label" label="Rewards" class="mb-1">
          <div v-for="(reward, rewardIndex) in rewardMilestones" :key="`reward-${rewardIndex}`"
            :class="['reward-item mt-1 d-flex align-items-center', { 'mb-2': rewardIndex < rewardMilestones.length - 1 }]">
            <p class="text-primary stamp-count flex-shrink-0">{{ `${reward.stamp_count} stamp` }}</p>
            <p class="info flex-grow-1">{{ `Free ${reward.reward_name}` }}</p>
          </div>
        </b-form-group>
        <b-form-group label-class="view-campaign-label" label="Terms and Conditions">
          <p class="info">{{ campaignDetails.terms_condition }}</p>
        </b-form-group>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { durationDisplay } from "./punch.card.utilities";
import _ from "lodash";

export default {
  props: {
    isShowView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapFields("punchCard", ["campaignDetails"]),
    rewardImage: {
      get() {
        return _.get(this.campaignDetails.milestones[0], "reward_image", null);
      },
      set(image) {
        return image;
      }
    },
    campaignDuration: {
      get() {
        const { date_start, date_end } = this.campaignDetails;

        if (date_start && date_end) return durationDisplay(date_start, date_end, "dateOnly");

        return null;
      },
      set(duration) {
        return duration;
      }
    },
    rewardMilestones: {
      get() {
        return _.sortBy(
          this.campaignDetails.milestones, "stamps_count"
        ).map(({ reward_name, stamps_count }) => ({
          stamp_count: this.stampCountDisplay(stamps_count),
          reward_name
        }));
      },
      set(milestones) {
        return milestones;
      }
    }
  },
  data() {
    return {
      isSlide: false
    }
  },
  methods: {
    slideRight() {
      this.isSlide = false;
      setTimeout(() => {
        this.$emit("hideCampaignView");
        this.campaignDetails = null;
      }, 300);
    },
    stampCountDisplay(count) {
      const stamp_count = count.toString()
      const last_digit = stamp_count.slice(-1);

      if (last_digit === "1") return `${stamp_count}st`;
      else if (last_digit === "2") return `${stamp_count}nd`;
      else if (last_digit === "3") return `${stamp_count}rd`;
      else return `${stamp_count}th`;
    }
  },
  watch: {
    isShowView(value) {
      if (value) {
        setTimeout(() => this.isSlide = value, 100);
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#punch-card-campaign-view-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.30);
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

#punch-card-campaign-view-container {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #fff;
  width: 55vw;
  height: 100vh;
  position: fixed;
  left: 100vw;
  transition: all 0.3s ease-in;
  padding: 24px 26px;

  &.shown {
    left: 45vw;
  }

  .view-details-container {
    margin-top: 40px;
    padding-left: 82px;
    padding-right: 60px;
    max-height: 87vh;
    overflow-y: auto;

    .campaign-image {
      width: 100%;
      height: 297px;
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 42px;

      &>img {
        object-fit: cover;
      }
    }

    h3 {
      font-family: MainFontBold, sans-serif;
      font-size: 20px;
      color: #2F3941;
      margin-bottom: 18px;
    }

    .description {
      font: 16px;
      color: #2F3941;
      line-height: 26px;
    }

    .info {
      font-family: MainFontBold, sans-serif;
      font-size: 16px;
      color: #2F3941;
    }

    .reward-item {
      .stamp-count {
        background-color: rgba($color: #FF6B00, $alpha: 0.1);
        border-radius: 10px;
        font-family: MainFontBold, sans-serif;
        font-size: 14px;
        padding: 10px;
        margin-right: 15px;
      }
    }
  }
}
</style>

<style lang="scss">
#punch-card-campaign-view-container {
  .view-campaign-label {
    font-size: 14px;
    color: #87929D;
  }
}
</style>
